import { Padding } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";

const DeleteDialog = ({ open, onClose, role ,onDelete}: any) => {
    console.log(role);

console.log(role);
    return (
        <Dialog sx={{
            "& .MuiDialog-paper": {
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "450px",
                height: "250px",
                transform: "translate(-50%, -50%)",
            },
        }}
            open={open} onClose={onClose} fullWidth>
            <DialogTitle sx={{pl:4}}> Are you sure you want to delete the role "{role?.name}"?</DialogTitle>
           <Typography sx={{ p: 2, pl:4 }}>
  If you delete, you will not be able to find the role again
</Typography>

           
              
            
            <DialogActions sx={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "15px" }}>
                <Button
                    sx={{ width: "120px", height:"40px" }}
                    onClick={() => {
                        onClose();
                    }}
                    variant="outlined">
                    Cancel
                </Button>
                <Button
                    sx={{ width: "120px", height:"40px",
                        backgroundColor: "error.danger", 
                        "&:hover": {
                          backgroundColor: "error.dark", 
                        }, 
                    }}
                    variant="contained"
                    color="error"
                    className={`btn btn-danger`}
                    type="submit"
                    onClick={() => {
                        onDelete(role); 
                        onClose();
                      }}
                    >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteDialog;